export default __webpack_public_path__ + "static/media/view.18b74409.png";